import type { ReactElement } from "react";
import { CmtsOrganizationUnitPage } from "../../pages/cmtsOrganizationUnitPage.js";
import type { CmtsHostRuntime } from "../../../app/appRuntime.js";

export function Component(_props: { readonly runtime: CmtsHostRuntime }): ReactElement {
  return <CmtsOrganizationUnitPage />;
}

export default Component;
